import { getDexfSettingsService } from '../../services/ServiceHandler';
import { setDexfSettings } from '../dexfSettings/dexfSettingsActions';
import { ActionCreator, Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import type { State } from '../StateTypes';
import type { IExtendedDexfSettings } from '../dexfSettings/dexfSettingsTypes';

const loadDexfSettings =
  (): ActionCreator<ThunkAction<Action, State, void, any>> => dispatch => {
    return getDexfSettingsService()
      .getApplicationSettings()
      .then((data: IExtendedDexfSettings) => {
        if (!data) {
          throw new Error('Dexf settings missing');
        }
        dispatch(setDexfSettings(data));
      });
  };

export default loadDexfSettings;
